import { UPDATE_USER_EMAIL } from './action-types';

export default Object.freeze({
  [UPDATE_USER_EMAIL]: {
    EMAIL_ADDRESS_ALREADY_EXISTS: 'The email address is already in use',
  },
});
